module.exports = __webpack_public_path__ + "img/sablior-2-150x52.70fd1114.png";